import React from 'react';
import styled from 'styled-components';
import { ReactComponent as IconUp } from '../../../../../../assets/svg/e_visit_up.svg';
import { ReactComponent as IconDown } from '../../../../../../assets/svg/e_visit_down.svg';

export const HandleTop = styled.div`
  width: 30px;
  height: 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-top-left-radius: 24px;
  border-top-right-radius: 24px;

  background: white;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.08));
`;

export const HandleBottom = styled.div`
  width: 30px;
  height: 14px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-bottom-left-radius: 24px;
  border-bottom-right-radius: 24px;

  background: white;
  filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.08));
`;

export const HandleUp: React.FunctionComponent = () => {
  return (
    <HandleTop>
      <IconUp />
    </HandleTop>
  );
};

export const HandleDown: React.FunctionComponent = () => {
  return (
    <HandleBottom>
      <IconDown />
    </HandleBottom>
  );
};
